import { createRouter, createWebHistory } from 'vue-router'
const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: () => import('../components/Login')
        },
        {
            path: '/controlaccess',
            name: 'ControlAccess',
            component: () => import('../components/ControlAccess')
        },
        {
            path: '/informationevent',
            name: 'InformationEvent',
            component: () => import('../components/InformationEvent')
        },
        {
            path: '/screen',
            name: 'ScreenView',
            component: () => import('../components/ScreenView')
        },
        {
            path: '/face',
            name: 'ScreenViewFace',
            component: () => import('../components/ScreenViewFace')
        },
        {
            path: '/controlaccessface',
            name: 'ControlAccessFace',
            component: () => import('../components/ControlAccessFace')
        },
        {
            path: '/controlaccessfacenew',
            name: 'ControlAccessFaceNew',
            component: () => import('../components/ControlAccessFaceNew')
        },
        {
            path: '/verificationidentification',
            name: 'VerificationInformation',
            component: () => import('../components/VerificationInformation')
        },

        {
            path: '/screenViewprintface',
            name: 'ScreenViewPrintFace',
            component: () => import('../components/ScreenViewPrintFace')
        },
        {
            path: '/moduleexhibitor',
            name: 'ModueloExpositor',
            component: () => import('../components/ModueloExpositor')
        },
        {
            path: '/:catchAll(.*)',
            name: "Redirect",
            component: () => import('../components/Login')

        }
    ]
})
export default router;